import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Space } from '../components/AntComponents';
import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <Title level={1} style={{ fontSize: '144px', margin: 0, opacity: 0.2 }}>404</Title>
          </div>
        </div>

        <Title level={2} style={{ marginBottom: '8px' }}>Page Not Found</Title>
        <Text type="secondary" style={{ marginBottom: '32px', display: 'block' }}>
          The page you're looking for doesn't exist. Let's get you back!
        </Text>

        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Space>
            <Button
              type="primary"
              icon={<ArrowLeftOutlined />}
              onClick={() => window.history?.back()}
            >
              Go Back
            </Button>

            <Button
              icon={<HomeOutlined />}
              onClick={handleGoHome}
            >
              Back to Home
            </Button>
          </Space>
        </Space>
      </div>
    </div>
  );
};

export default NotFound;
